import { useEffect, useMemo, useCallback } from "react";
import { useParams } from "react-router-dom";
import { useParent } from "../../../contexts/ParentContext";
import { useCase } from "../../../contexts/CaseContext";
import { useAccount } from "../../../contexts/AccountContext";

export const useParentDetail = () => {
  const { isChatEnabled } = useAccount();
  const { cases } = useCase();
  const { parentId } = useParams<{ parentId: string }>();
  const { selectedParent, setSelectedParent, loading, error } = useParent();

  const caseInfo = useMemo(() => {
    if (!selectedParent?.caseId || !cases.length) return null;
    return cases.find((c) => c.id === selectedParent.caseId);
  }, [selectedParent?.caseId, cases]);

  // Callback for setting selected parent
  const handleSetSelectedParent = useCallback((id: string) => {
    setSelectedParent(id);
  }, [setSelectedParent]);

  useEffect(() => {
    if (parentId) {
      handleSetSelectedParent(parentId);
    }
  }, [parentId, handleSetSelectedParent]);

  return {
    selectedParent,
    loading,
    error,
    caseInfo,
    isChatEnabled,
  };
}; 